module.exports = __webpack_public_path__ + "static/media/gift07_ja.a71387d3.png";